import React from "react";
import { Link } from "react-router-dom";

const Subnav = () => {
  return (
    <div className="sticky top-14 z-50 bg-gray-800 text-white shadow-md">
      <div className="max-w-screen-xl mx-auto px-4 py-2 flex justify-between items-center">
        <ul className="flex space-x-6">
         
          <li>
            <Link
              to="/sale/history"
              className="text-lg hover:text-blue-400"
            >
              Sale History
            </Link>
          </li>
          <li>
            <Link
              to="/sale/add-sale"
              className="text-lg hover:text-blue-400"
            >
              Add Sale
            </Link>
          </li>
          
        </ul>
      </div>
    </div>
  );
};

export default Subnav;
